import React, { Dispatch, SetStateAction } from "react";
import { ModuleI } from "../../../types";
import Input from "../../../componentLibrary/Input";
import ColorPicker from "../../../componentLibrary/ColorPicker";

export default function ColorSelect({
  module,
  setModule,
  disabled = false,
}: {
  module: ModuleI;
  setModule: Dispatch<SetStateAction<ModuleI>>;
  disabled?: boolean;
}) {
  return (
    <div className="flex flex-row justify-between">
      <Input
        value={module.color.toUpperCase()}
        className="w-2/3"
        label="Color"
        disabled
      />
      <ColorPicker
        selectedColor={module.color}
        handleColorChange={(event) =>
          setModule((prev) => ({
            ...prev,
            color: event.target.value,
          }))
        }
        disabled={disabled}
      />
    </div>
  );
}
